export default __webpack_public_path__ + "static/media/tools-bj-bottom.a51d7aa3.png";